import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    subscription: null
  },
  mutations: {
    setSubscription(state, subscription) {
      state.subscription = subscription;
    }
  },
  actions: {
    // how to use
    // this.$store.dispatch('setStripeCustomerId', 1);
    setSubscription({ commit }, subscription) {
      commit('setSubscription', subscription);
    }
  },
  getters: {
    subscription: state => state.subscription
  }
});